import React from "react";

const OPTIONS = [
  { value: 1, label: "1 mo" },
  { value: 6, label: "6 mo" },
  { value: 12, label: "12 mo" },
  { value: 24, label: "24 mo" },
];

const CalendarViewSpanToggle = ({ value, onChange }) => (
  <fieldset className="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-0.5">
    <legend className="sr-only">Calendar view range</legend>
    {OPTIONS.map((option) => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        aria-pressed={value === option.value}
        className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
          value === option.value
            ? "bg-white text-indigo-700 shadow-sm ring-1 ring-gray-200"
            : "text-gray-600 hover:text-gray-900"
        }`}
      >
        {option.label}
      </button>
    ))}
  </fieldset>
);

export default CalendarViewSpanToggle;
